import { render } from "./userCard.vue?vue&type=template&id=5df0cb20&scoped=true"
import script from "./userCard.vue?vue&type=script&lang=js"
export * from "./userCard.vue?vue&type=script&lang=js"

import "./userCard.vue?vue&type=style&index=0&id=5df0cb20&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5df0cb20"]])

export default __exports__